.Outer {
  padding: 20px;
}

.Inner {
  display: flex;
  gap: 2rem;
  width: 100%;
}

.ChatPane {
  width: 30%;
  overflow-y: scroll;
  height: calc(100vh - 100px);

  & textarea {
    width: 100%;
  }
}

.CalendarPane {
  width: 60%;
  height: 80vh;

  & :global(.rbc-events-container > div) {
    padding: 0.25rem;
  }

  & :global(.rbc-event-content) {
    font-size: 0.75rem;
  }
}
